export default "__VITE_ASSET__VlzTu1YQ__"